import { Box, Flex, Text, Button, Image } from "@chakra-ui/react";
import { t } from "i18next";

// Figma: https://www.figma.com/design/z9Ut4lxLJQZK28vEZiHRwN/Monthly-rewards?node-id=122-4519

interface GoldUpsellBannerProps {
  onSubscribe: () => void;
  isSmall: boolean;
}

export function GoldUpsellBanner({ onSubscribe, isSmall }: GoldUpsellBannerProps) {
  return (
    <Flex direction="column" gap="32px" w="100%">
      <Box height="1px" w="100%" bg="whiteAlpha.200" />
      <Flex
        align="center"
        justify="space-between"
        direction={isSmall ? "column" : "row"}
        borderRadius="24px"
        gap={isSmall ? "24px" : "40px"}
      >
        {/* Left: text + CTA */}
        <Flex direction="column" gap={isSmall ? "24px" : "40px"} flexShrink={0} maxW={isSmall ? "100%" : "535px"}>
          <Flex direction="column" gap="16px">
            <Text
              fontFamily="Bricolage Grotesque"
              fontSize={isSmall ? "20px" : "24px"}
              fontWeight={600}
              color="dune.dune"
              letterSpacing="-0.48px"
            >
              {t("screens.monthlyComics.upsellTitle")}
            </Text>
            <Text
              fontSize="16px"
              fontWeight={400}
              color="dune.700"
              lineHeight={1.4}
            >
              {t("screens.monthlyComics.upsellDescription")}
            </Text>
          </Flex>
          <Box>
            <Button
              h="48px"
              px="32px"
              borderRadius="20px"
              bg="blaze.600"
              color="white"
              fontWeight={500}
              fontSize="18px"
              letterSpacing="0.75px"
              boxShadow="0px 8px 12px rgba(0,0,0,0.2)"
              _hover={{ bg: "blaze.700" }}
              _active={{ bg: "blaze.800" }}
              gc-testing-id="btnBecomeMember"
              onClick={onSubscribe}
            >
              {t("screens.monthlyComics.upsellCta")}
            </Button>
          </Box>
        </Flex>

        {/* Right: fan of comic covers */}
        {!isSmall && (
          <Image
            src={`${window.gc?.global?.assets_url ?? ""}/static/images/web-ui/gold-upsell/fan-covers.png`}
            alt={t("screens.monthlyComics.upsellCoversAlt")}
            h="205px"
            w="auto"
            objectFit="contain"
            flexShrink={0}
          />
        )}
      </Flex>
    </Flex>
  );
}
